import { createContext, useContext, useState } from 'react';

const OnboardingContext = createContext(null);

export const OnboardingProvider = ({ children }) => {
    const [isSignatureConfirm, setIsSignatureConfirm] = useState(false)
    const [incomeDocsArr, setIncomeDocArr] = useState([])
    const [countryCode, setCountryCode] = useState("")

    const values = {
        isSignatureConfirm,
        setIsSignatureConfirm,
        incomeDocsArr,
        setIncomeDocArr,
        countryCode,
        setCountryCode
    }

    return (
        <OnboardingContext.Provider value={values}>
            {children}
        </OnboardingContext.Provider>
    );
};

export const useOnboardingContext = () => {
    return useContext(OnboardingContext);
};

export { OnboardingContext };